module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-compact-container"
  }, [_c('div', {
    staticClass: "progress-compact"
  }, [_c('div', {
    staticClass: "progress-compact-label"
  }, [_vm._v(_vm._s(_vm.progress.title || ''))]), _vm._v(" "), _c('span', {
    staticClass: "progress-success",
    style: ({
      width: _vm.complete
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "progress-fail",
    style: ({
      width: _vm.error
    })
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f46d748c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressBar.vue
// module id = 1128
// module chunks = 0